import { gql } from 'apollo-angular';

export interface InvolvedAgencyPair {
  applicantAgencyId: number;
  imAgencyId: number;
}

export interface ValidateNationalTrainNumber {
  excludeDossierId?: number;
  ttpId: number;
  involvedAgencyPairs: InvolvedAgencyPair[];
  nationalTrainNumber: string;
}

export interface InvalidNationalTrainNumber {
  involvedAgencyPair: InvolvedAgencyPair;
  nationalTrainNumber: string;
}

export const invalidNationalTrainNumber = gql`
    fragment invalidNationalTrainNumber on InvalidNationalTrainNumber {
        nationalTrainNumber
        involvedAgencyPair {
            applicantAgencyId
            imAgencyId
        }
    }
`;

